import { isNull } from '@/libs/basics-tools'

export const amountFilter = (value) => {
  return isNull(value) ? 0 : (value / 100).toFixed(2)
}
export const formatTime = (val) => {
    let valNum = Number(val)
    let timeStr = ''
    if((valNum / 3600) < 1){
      timeStr = valNum / 60 + '分钟'
    }else if((valNum / 3600) < 24){
      timeStr = valNum / 3600 + '小时'
    }else{
      timeStr = valNum / (3600 * 24) + '天'
    }
    return timeStr
  }